"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _constants = require("../utils/constants");

var _FormItem = _interopRequireDefault(require("./FormItem"));

var _FormLabel = _interopRequireDefault(require("./FormLabel"));

var _FormValidationOverlay = _interopRequireDefault(require("./_FormValidationOverlay"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _checkbox = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/checkbox.css") : void 0);

/* eslint-disable valid-jsdoc */
var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _checkbox.default);
/** With a **Checkbox**, all options are visible and the user can make one or more selections.
This component can also be disabled and displayed in a row */

var Checkbox = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _classnames;

  var ariaLabel = _ref.ariaLabel,
      checked = _ref.checked,
      children = _ref.children,
      cssNamespace = _ref.cssNamespace,
      textClassName = _ref.textClassName,
      compact = _ref.compact,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      id = _ref.id,
      indeterminate = _ref.indeterminate,
      inline = _ref.inline,
      inputClassName = _ref.inputClassName,
      inputProps = _ref.inputProps,
      labelClassName = _ref.labelClassName,
      labelProps = _ref.labelProps,
      name = _ref.name,
      _onChange = _ref.onChange,
      value = _ref.value,
      validationOverlayProps = _ref.validationOverlayProps,
      validationState = _ref.validationState,
      props = (0, _objectWithoutProperties2.default)(_ref, ["ariaLabel", "checked", "children", "cssNamespace", "textClassName", "compact", "defaultChecked", "disabled", "id", "indeterminate", "inline", "inputClassName", "inputProps", "labelClassName", "labelProps", "name", "onChange", "value", "validationOverlayProps", "validationState"]);

  var _useState = (0, _react.useState)(!!checked),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      checkedState = _useState2[0],
      setCheckedState = _useState2[1];

  var inputEl = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    inputEl && inputEl.current && (inputEl.current.indeterminate = indeterminate);
  });
  var inputClassNames = classnames("".concat(cssNamespace, "-checkbox"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "is-".concat(validationState === null || validationState === void 0 ? void 0 : validationState.state), validationState === null || validationState === void 0 ? void 0 : validationState.state), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-checkbox--compact"), compact), _classnames), inputClassName);
  var labelClasses = classnames("".concat(cssNamespace, "-checkbox__label"), labelClassName);
  var childrenClasses = classnames("".concat(cssNamespace, "-checkbox__text"), textClassName);
  var checkId = (0, _useUniqueId.default)(id);
  var checkboxChildren = typeof children === 'string' ? /*#__PURE__*/_react.default.createElement("span", {
    className: childrenClasses
  }, children) : children;

  var checkbox = /*#__PURE__*/_react.default.createElement(_FormItem.default, (0, _extends2.default)({}, props, {
    disabled: disabled,
    isInline: inline,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, inputProps, {
    "aria-checked": checkedState,
    "aria-label": ariaLabel,
    checked: checked,
    className: inputClassNames,
    defaultChecked: defaultChecked,
    disabled: disabled,
    id: checkId,
    name: name,
    onChange: function onChange(e) {
      var toggledState = !checkedState;
      setCheckedState(toggledState);

      _onChange(e, toggledState);
    },
    ref: inputEl,
    type: "checkbox",
    value: value
  })), /*#__PURE__*/_react.default.createElement(_FormLabel.default, (0, _extends2.default)({}, labelProps, {
    className: labelClasses,
    disabled: disabled,
    htmlFor: checkId
  }), checkboxChildren));

  return validationState ? /*#__PURE__*/_react.default.createElement(_FormValidationOverlay.default, (0, _extends2.default)({}, validationOverlayProps, {
    control: checkbox,
    validationState: validationState
  })) : checkbox;
});

Checkbox.displayName = 'Checkbox';
process.env.NODE_ENV !== "production" ? Checkbox.propTypes = {
  /** aria-label for the checkbox when no visible label is used */
  ariaLabel: _propTypes.default.string,

  /** Set to **true** when checkbox input is checked and a controlled component */
  checked: _propTypes.default.bool,

  /** Node(s) to render within the component */
  children: function children(props, propName, componentName) {
    if (!props.children && !props.ariaLabel) {
      return new Error("\nNo `children` or `aria-label` found for ".concat(componentName, ".\nPlease ensure you are either using a visible `FormLabel` or an `aria-label` for accessibility purposes.\n"));
    }
  },

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** Set to **true** when the checkbox input is checked and an uncontrolled component */
  defaultChecked: _propTypes.default.bool,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Value for the `id` attribute on the element */
  id: _propTypes.default.string,

  /** When true, the checkbox renders a "mixed" state */
  indeterminate: _propTypes.default.bool,

  /** Internal use only */
  inline: _propTypes.default.bool,

  /** Class name to be added to the component `<input>` element */
  inputClassName: _propTypes.default.string,

  /** Additional props to be spread to the `<input>` element */
  inputProps: _propTypes.default.object,

  /** Class name to be added to the component `<label>` element */
  labelClassName: _propTypes.default.string,

  /** Additional props to be spread to the `<label>` element */
  labelProps: _propTypes.default.object,

  /** Sets the `name` for the checkbox input */
  name: _propTypes.default.string,

  /** Additional classes to apply to children */
  textClassName: _propTypes.default.string,

  /** Additional props to be spread to the ValidationOverlay */
  validationOverlayProps: _propTypes.default.shape({
    /** Additional classes to apply to validation popover's outermost `<div>` element  */
    className: _propTypes.default.string,

    /** Additional props to be spread to the ValdiationOverlay's FormMessage component */
    formMessageProps: _propTypes.default.object,

    /** Additional classes to apply to validation popover's popper child `<div>` wrapping the provided children  */
    innerRefClassName: _propTypes.default.string,

    /** Additional classes to apply to validation popover's popper `<div>` element  */
    popperClassName: _propTypes.default.string,

    /** CSS class(es) to add to the ValidationOverlay's reference `<div>` element */
    referenceClassName: _propTypes.default.string,

    /** Additional props to be spread to the popover's outermost `<div>` element */
    wrapperProps: _propTypes.default.object
  }),

  /** An object identifying a validation message.  The object will include properties for `state` and `text`; _e.g._, \`{ state: \'warning\', text: \'This is your last warning\' }\` */
  validationState: _propTypes.default.shape({
    /** State of validation: 'error', 'warning', 'information', 'success' */
    state: _propTypes.default.oneOf(_constants.FORM_MESSAGE_TYPES),

    /** Text of the validation message */
    text: _propTypes.default.string
  }),

  /** Sets the `value` for the checkbox input */
  value: _propTypes.default.string,

  /**
   * Callback function; triggered when the change event fires on the HTML checkbox `<input>`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @param {Boolean} checkedState - represents the final checked state of the HTML checkbox input.
   * @returns {void}
  */
  onChange: _propTypes.default.func
} : void 0;
Checkbox.defaultProps = {
  onChange: function onChange() {}
};

var _default = (0, _withStyles.default)(Checkbox);

exports.default = _default;